import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import UserSettingsWorkplace from './UserSettingsWorkplace';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	userId: string;
}

const UserSettingsWorkplaceModal: React.FC<Props> = props => (
	<BaseModal {...props} title='base.myWorkplace' size={Size.MD}>
		<UserSettingsWorkplace userId={props.userId} onConfirm={props.onClose} />
	</BaseModal>
);

export default UserSettingsWorkplaceModal;
